const REDUNDANT_ALT_PREFIX = /^(image of|photo of|picture of|graphic of)\s+/i

function normalize(value: string): string {
    return value.replace(/\s+/g, " ").trim().toLowerCase()
}

/** Drop CMS alts that only repeat nearby text, or start with "image of". */
export function getAccessibleImageAlt(
    alt?: string | null,
    adjacentText?: string | null
): string {
    if (!alt?.trim()) return ""

    const stripped = alt.replace(REDUNDANT_ALT_PREFIX, "").trim()
    if (!stripped) return ""

    if (adjacentText?.trim()) {
        const adjacent = normalize(adjacentText)
        if (normalize(alt) === adjacent || normalize(stripped) === adjacent) {
            return ""
        }
    }

    return stripped
}
